var _excluded = ["className"];

var _templateObject, _templateObject2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import cx from 'classnames';
import { useField } from 'formik';
var Paddle = styled.span(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  display: inline-block;\n  height: 18px;\n  width: 18px;\n  background: var(--toggle-paddle-color, #ffffff);\n  border-radius: 50%;\n  transition: var(--transition);\n\n  &::before,\n  &::after {\n    opacity: 0;\n    position: absolute;\n    display: inline-block;\n    top: 50%;\n    transform: translateY(-50%);\n    transition: .1s opacity ease;\n\n    font-size: 10px;\n    font-weight: bold;\n    line-height: 11.72px;\n    color: var(--toggle-font-color, inherit);\n  }\n\n  &::before {\n    content: \"NO\";\n    right: 10px;\n  }\n\n  &::after {\n    content: \"YES\";\n    text-align: left;\n    left: 8px;\n  }\n"])));
var Wrapper = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n  --transition: .3s all ease;\n\n  width: 54px;\n  height: 22px;\n  position: relative;\n  display: inline-flex;\n  flex-direction: column;\n  justify-content: space-around;\n  border-radius: 16px;\n  padding: 1px;\n  border: 1px solid var(--toggle-border-color);\n  background-color: var(--toggle-background-color-inactive);\n  font-weight: 700;\n  cursor: pointer;\n\n  transition: var(--transition);\n\n  ", " {\n    &::before {\n      opacity: 1;\n    }\n    &::after {\n      opacity: 0;\n    }\n  }\n\n  &.active {\n    background-color: var(--toggle-background-color-active);\n\n    ", " {\n      margin-left: 65%;\n\n      &::before {\n        opacity: 0;\n      }\n      &::after {\n        opacity: 1;\n      }\n    }\n  }\n\n  input { display: none; }\n"])), Paddle, Paddle);
var Toggle = React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  var type = 'checkbox';
  var innerRef = React.useRef(ref);

  var _useField = useField(_extends({
    type: type
  }, props)),
      field = _useField[0];

  var handleClick = function handleClick() {
    return innerRef.current.click();
  };

  return /*#__PURE__*/React.createElement(Wrapper, {
    className: cx(className, {
      active: field.checked
    }),
    onClick: handleClick
  }, /*#__PURE__*/React.createElement(Paddle, null), /*#__PURE__*/React.createElement("input", _extends({
    ref: innerRef
  }, props, field, {
    type: type
  })));
});
Toggle.propTypes = process.env.NODE_ENV !== "production" ? {
  type: PropTypes.string,
  className: PropTypes.string
} : {};
export default Toggle;